module.exports = __webpack_public_path__ + "img/btn_product_03_pause@2x.f99d5a4b.png";